export enum GlobalErrorType {
  NotAuthorized = 1,
}
